export default function HomeFAQ() {
  const faqs = [
    {
      q: '韩漫网提供哪些类型的韩国漫画？',
      a: '韩漫网收录涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、恐怖、校园、职场、古风、运动、转生等十二大类型的韩国漫画全集，内容丰富多样，满足不同读者的阅读偏好。',
    },
    {
      q: '韩漫下拉式阅读有什么优势？',
      a: '下拉式阅读是专为手机和网页优化的漫画阅读方式。您只需向下滑动即可连续阅读，无需翻页，阅读体验丝滑流畅，特别适合长条漫画格式。韩漫网全面支持漫画免费下拉式阅读。',
    },
    {
      q: '韩漫网的漫画更新频率如何？',
      a: '韩漫网与多家韩国漫画平台保持同步更新，热门连载漫画每日更新，完结漫画可一次性畅读全集。我们致力于为用户提供最新最快的韩漫在线阅读服务。',
    },
    {
      q: '如何在韩漫网找到好看的韩国漫画？',
      a: '您可以通过首页的搜索框直接搜索漫画名称，也可以通过分类导航按类型浏览。此外，首页的"推荐漫画"、"最新更新"和"热门排行"版块汇集了最受欢迎的韩漫作品，方便您快速发现好看的内容。',
    },
    {
      q: '韩漫网需要注册才能阅读吗？',
      a: '韩漫网目前为完全开放的阅读平台，无需注册即可免费在线阅读所有漫画内容。我们致力于为韩漫爱好者提供便捷的韩漫在线观看服务。',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              常见问题
            </h2>
            <p className="mt-2 text-sm text-foreground-500">关于韩漫网的使用，您想了解的都在这</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group rounded-xl bg-background-100 border border-background-200/70">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</h3>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}